import { sortTableRow } from "./sortTableRow";

  // Agrupa as alternativas por titulo_grade
  export const groupAlternativesByGroup = (alternativas) => {
    const groups = {};
    alternativas.forEach((alternativa) => {
      if (!groups[alternativa.titulo_grade]) {
        groups[alternativa.titulo_grade] = [];
      }
      groups[alternativa.titulo_grade].push(alternativa);
    });
    
    // Ordena as alternativas dentro de cada grupo
    Object.keys(groups).forEach((group) => {
      groups[group] = sortTableRow(groups[group]);
    });
    
    return groups;
  };
